import request from '@/utils/request'
import { apiConsolelog } from '@/utils/tracelog'

export function getAssociates (textSize) {
  apiConsolelog('api: getAssociates(): textSize = %s', textSize)

  return request({
    url: '/associates/show',
    method: 'get',
    text_size: textSize
  })
}
